window.$ = window.jQuery = require('jquery');

require('../vendor/simple-scrollbar.min');
require('../vendor/jquery.serialize-object.min');
require('../vendor/owl.carousel.min');